import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Search, Truck } from 'lucide-react';

const BottomNav = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  const items = [
    { id: 'dashboard', icon: LayoutDashboard, label: 'Início',  path: '/' },
    { id: 'pedidos',   icon: Search,          label: 'Pedidos', path: '/consultar' },
    { id: 'cotacao',   icon: Truck,           label: 'Cotação', path: '/cotacao-frete' },
  ];

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200"
      style={{ boxShadow: '0 -2px 12px rgba(0,0,0,0.08)', paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="bottom-nav"
    >
      <div className="flex justify-around items-stretch h-16">
        {items.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              data-testid={`bottom-nav-${item.id}`}
              className={`flex flex-col items-center justify-center flex-1 gap-0.5 transition-all active:scale-95 ${
                active ? 'text-[#1B8B4E]' : 'text-gray-400'
              }`}
              style={{ minHeight: 44 }}
            >
              <item.icon
                size={22}
                strokeWidth={active ? 2.5 : 1.8}
                className="transition-all"
              />
              <span className={`text-[10px] font-medium leading-none ${active ? 'font-semibold' : ''}`}>
                {item.label}
              </span>
              {active && (
                <span className="absolute bottom-0 w-6 h-0.5 bg-[#1B8B4E] rounded-t-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
